import { useEffect, useState, type FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, errMsg } from "../api";
import { Brand } from "../components/Brand";
import { Btn, Field, Input, Notice } from "../components/ui";

/** Pede o link de redefinição por e-mail. A resposta é sempre a mesma, exista ou não o e-mail. */
export function ForgotPassword({ realm }: { realm: "pf" | "pj" }) {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await api("POST", `/api/${realm}/auth/password/forgot`, { email });
      setSent(true);
    } catch (e2) { setErr(errMsg(e2)); } finally { setBusy(false); }
  }

  return (
    <div className="auth-wrap">
      <div className="auth-card card">
        <Brand />
        <h1>Esqueci minha senha — {realm === "pf" ? "Pessoa Física" : "Pessoa Jurídica"}</h1>
        {sent ? (
          <>
            <Notice kind="ok">Se este e-mail tiver cadastro, enviamos um link para redefinir a senha. Ele vale por 30 minutos. Confira também a caixa de spam.</Notice>
            <p className="muted">Por segurança, o código do aplicativo autenticador (2FA) continua sendo exigido ao entrar.</p>
          </>
        ) : (
          <>
            <p className="muted" style={{ marginTop: 0 }}>Informe o e-mail do seu usuário. Você receberá um link para criar uma nova senha.</p>
            {err && <Notice kind="error">{err}</Notice>}
            <form onSubmit={submit}>
              <Field label="E-mail"><Input type="email" autoComplete="username" required autoFocus value={email} onChange={(e) => setEmail(e.target.value)} /></Field>
              <Btn type="submit" block disabled={busy}>Enviar link</Btn>
            </form>
          </>
        )}
        <p className="muted" style={{ textAlign: "center", marginBottom: 0 }}><Link to={`/${realm}/entrar`}>Voltar para entrar</Link></p>
      </div>
    </div>
  );
}

/** Define a nova senha. O token vem no fragmento (#t=...) do link: não vai para registros do servidor nem para outros sites. */
export function ResetPassword({ realm }: { realm: "pf" | "pj" }) {
  const nav = useNavigate();
  const [token, setToken] = useState("");
  const [password, setPassword] = useState("");
  const [again, setAgain] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const m = /(?:^|[#&])t=([^&]+)/.exec(window.location.hash);
    setToken(m ? decodeURIComponent(m[1]!) : "");
    if (m) window.history.replaceState(null, "", window.location.pathname);
  }, []);

  async function submit(e: FormEvent) {
    e.preventDefault();
    if (password !== again) { setErr("As senhas não conferem."); return; }
    setBusy(true); setErr("");
    try {
      await api("POST", `/api/${realm}/auth/password/reset`, { token, password });
      nav(`/${realm}/entrar?senha=redefinida`, { replace: true });
    } catch (e2) { setErr(errMsg(e2)); } finally { setBusy(false); }
  }

  return (
    <div className="auth-wrap">
      <div className="auth-card card">
        <Brand />
        <h1>Nova senha — {realm === "pf" ? "Pessoa Física" : "Pessoa Jurídica"}</h1>
        {!token ? (
          <>
            <Notice kind="error">Link inválido ou incompleto. Peça um novo link.</Notice>
            <p style={{ textAlign: "center" }}><Link to={`/${realm}/esqueci-senha`}>Pedir novo link</Link></p>
          </>
        ) : (
          <>
            {err && <Notice kind="error">{err}</Notice>}
            <form onSubmit={submit}>
              <Field label="Nova senha (mínimo 10 caracteres, com letras e números)"><Input type="password" autoComplete="new-password" required minLength={10} autoFocus value={password} onChange={(e) => setPassword(e.target.value)} /></Field>
              <Field label="Repita a nova senha"><Input type="password" autoComplete="new-password" required minLength={10} value={again} onChange={(e) => setAgain(e.target.value)} /></Field>
              <Btn type="submit" block disabled={busy}>Salvar nova senha</Btn>
            </form>
            <p className="muted" style={{ textAlign: "center", marginBottom: 0 }}>Se o link expirou, <Link to={`/${realm}/esqueci-senha`}>peça um novo</Link>.</p>
          </>
        )}
      </div>
    </div>
  );
}
